<template>
    <div name="list" class="list">
        <pharmacy-card 
            v-for="(pharmacy, index) in pharmacies" :key="`${pharmacy.index}_${index}`"
            :info="pharmacy"
            :isList="true"
            @share="share"
            @changeMapView="changeView"
            @viewMaps="viewMaps"
            @viewDetail="viewDetail"
            style="margin-bottom: 8px;"
        />
        <div v-if="pharmacies.length === 0" class="empty">
            <img style="width: 90px;" src="../../../assets/icn_search_big.png" />
            <span style="margin-top: 30px;" class="empty-title">검색 결과가 없습니다.</span>
            <span style="margin-top: 16px;" class="description">알고 있는 약국이 검색결과에 없거나<br>
                내 주변 인슐린 약국이 안 보인다면<br>
                저희에게 알려주세요.</span>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import Constant from '@/constant';
import PharmacyCard from '@/components/molecules/maps/PharmacyCard';
export default {
    components: {
        PharmacyCard
    },
    mounted: function()
    {
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8"
        });
    },
    computed: mapState(['pharmacies', 'zoomLevel']),
    methods: {
        changeView: function()
        {
            this.$emit('modeChange', this.zoomLevel)
        },
        viewMaps: function(info)
        {
            this.$emit('viewMaps', info)
        },
        viewDetail: function(info)
        {
            console.log("list: " + JSON.stringify(info))
            this.$emit('viewDetail', info)
        },
        share: function(info)
        {
            this.$emit('share', info)
        }
    },
    watch: {

    }
}
</script>

<style scoped>
    .list {
        width: 100%;
        display: inline-block;
        flex-direction: column;
        justify-content: flex-start;
        background: var(--Gray-sub-color1, #F3F5F8);
        overflow-y: auto;
    }
    .empty {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        padding: 60px 0 152px 0;
        background: var(--Gray-primary-color2, #FFF);
    }
    .empty-title {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px; /* 94.444% */
    }
    .description {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/map/List.vue